import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Contact.module.css';

// Your script URL remains the same
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbyyJOZ2YSHsxq2KTzYvXjK6K36Dzf5w2yhXj2gE8Y9afk1o0xVNKXHBpm9HBByh2ppe/exec";

const Contact = () => {
  // We don't need individual states anymore, which is cleaner
  const [formState, setFormState] = useState({
    submitting: false,
    status: null,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormState({ submitting: true, status: { text: 'Sending...', type: 'info' } });

    // Use FormData to capture the form's data
    const formData = new FormData(e.target);

    fetch(SCRIPT_URL, {
      method: 'POST',
      body: formData, // Send the FormData object directly
    })
    .then(response => {
        // The fetch doesn't fail, so we can assume success
        setFormState({ submitting: false, status: { text: 'Thank you! Your message has been sent.', type: 'success' } });
        e.target.reset(); // Reset the form fields
    })
    .catch((error) => {
      // Handle network errors
      console.error('Fetch Error:', error);
      setFormState({ submitting: false, status: { text: 'Oops! Something went wrong. Please try again.', type: 'error' } });
    });
  };

  return (
    <section id="contact" className={styles.contactWrapper}>
      <div className={styles.contact}>
        <div className={styles.cta}>
          <h2>Ready to Transform Your Music Studio?</h2>
          <p>Get a professional AI-generated website and smart scheduling system. Stop losing students to competitors and start growing your studio today.</p>

        </div>


        <form className={styles.form} onSubmit={handleSubmit}>
          <h3>Send us a message</h3>
          <input 
            type="text" 
            placeholder="Your Name" 
            name="name" // The 'name' attribute must match the script's 'e.parameter.name'
            required 
          />
          <input 
            type="email" 
            placeholder="Your Email" 
            name="email" // The 'name' attribute must match the script's 'e.parameter.email'
            required 
          />
          <textarea 
            placeholder="Your Message" 
            rows="5" 
            name="message" // The 'name' attribute must match the script's 'e.parameter.message'
            required
          ></textarea>
          
          <div className={styles.consentSection}>
                          <p className={styles.consentText}>
                By submitting this form, you agree to receive recurring automated promotional and personalized marketing text messages from us at your cell number. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies.
                Msg and data rates may apply. View <Link to="/terms-of-service" className={styles.consentLink}>Terms</Link> & <Link to="/privacy-policy" className={styles.consentLink}>Privacy</Link>
              </p>
          </div>
          
          <button type="submit" disabled={formState.submitting}>
            {formState.submitting ? 'Sending...' : 'Send Message'}
          </button>

          {formState.status && <p className={styles.statusMessage}>{formState.status.text}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;